// extracted by mini-css-extract-plugin
export default {"tableHeader":"style_tableHeader__DNFH7"};